import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { openTrue } from "./openTrueAPI";

const initialState = {
    status: "idle",
    NewQuestion:'',
    NewQuestionTimer: '',
    Attributes: [],
    UsedQuestionsId:[],
    LastCard: false,
}

export const openTrueAsync = createAsyncThunk(
    "/opentrue",
    async ({gender, player},{getState, rejectWithValue}) => {
        try {
            const state = getState()
            const usedid = state.openTrue.UsedQuestionsId
            const sessionid = state.gameStatus.sessions['open'].sessionId

            
            
            const response = await openTrue(gender, player, usedid, sessionid);
            return response
        } catch (error) {
            console.error("Error in openTrueAsync:", error); // 👀 This should appear now
            return rejectWithValue(error.response
                ? { data: error.response.data, status: error.response.status }
                : { data: { error: "Unknown error" }, status: 500 })
        }
    }
)

export const openTrueSlice = createSlice({
    name: "opentrue",
    initialState,
    reducers: {
        resetState:(state) =>{
            state.status ="idle"
            state.NewQuestion = ''
            state.NewQuestionTimer = ''
            state.Attributes = []
            state.UsedQuestionsId =[]
            state.LastCard = false;
        },
    },
    extraReducers:(builder) => {
        builder
            .addCase(openTrueAsync.pending, (state) => {
                state.status = 'fetching';
            })
            .addCase(openTrueAsync.fulfilled, (state, action)=>{
                state.status ="fulfilled";
                state.NewQuestion = action.payload.question
                state.NewQuestionTimer = action.payload.timer
                state.UsedQuestionsId = [...state.UsedQuestionsId,action.payload.id]
                state.Attributes = [action.payload.attributes]
                state.LastCard = action.payload.last_card || false;
            })}})

export const selectOpenTrue = (state) => state.openTrue
export const {resetState} = openTrueSlice.actions;

export default openTrueSlice.reducer